module.exports = "attribute vec3 position;\r\nattribute vec4 color;\r\nvarying vec4 v_color;\r\n\r\nvoid main() {\r\n    gl_Position = czm_modelViewProjection * vec4(position, 1.0);\r\n    v_color = color;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/default.vs.glsl
// module id = 5
// module chunks = 0